import React, { Component } from "react";
import Result from "../components/Search/Result";
import dynamicPortal from "../utils/dynamicPortal";
import PaginatedItems from "../components/Common/PaginatedItems";

export class SearchPortal extends Component {
  render() {
    return dynamicPortal.load(".js-react-search-result", (config) => (
      <PaginatedItems itemsPerPage={25} items={config.Items}>
        {(pageItems) => pageItems.map((item) => <Result {...item} />)}
      </PaginatedItems>
    ));
  }
}

export default SearchPortal;



// WEBPACK FOOTER //
// ./src/portals/SearchPortal.js